import { render, staticRenderFns } from "./ItemProductModal.vue?vue&type=template&id=39c48e0e&scoped=true"
import script from "./ItemProductModal.vue?vue&type=script&lang=js"
export * from "./ItemProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c48e0e",
  null
  
)

export default component.exports